const getFeatures = () => {
    try {
        return JSON.parse(localStorage.getItem('userFeatures') || '[]');
    } catch {
        return [];
    }
};

const useFeatures = () => {
    const features = getFeatures();
    const isSuperAdmin = features.includes('superadmin') || features.includes('all');

    const hasFeature = (key) => {
        if (!key) return true;
        if (isSuperAdmin) return true;
        return features.includes(key);
    };

    return { features, hasFeature, isSuperAdmin };
};

export default useFeatures;
